module.exports = __webpack_public_path__ + "img/rw.a712fac2.png";